/* eslint-disable eslint-comments/disable-enable-pair */

/* eslint-disable no-template-curly-in-string */
import dataStates from '@emmacare/common/data/states.json'

import { PRIORITY } from 'src/constants/common/statuses'
import { addAllValue } from 'src/utils/DataTrees'
import { addAllValue as addAllValueV5 } from 'src/utils/v5/DataTrees'

export const WEEK_DAYS = [
  { key: 0, value: 7, label: 'Su', full: 'Sunday' },
  { key: 1, value: 1, label: 'Mo', full: 'Monday' },
  { key: 2, value: 2, label: 'Tu', full: 'Tuesday' },
  { key: 3, value: 3, label: 'We', full: 'Wednesday' },
  { key: 4, value: 4, label: 'Th', full: 'Thursday' },
  { key: 5, value: 5, label: 'Fr', full: 'Friday' },
  { key: 6, value: 6, label: 'Sa', full: 'Saturday' }
]

export const WEEK_DAYS_MAP = [
  [7, 'Sunday'],
  [1, 'Monday'],
  [2, 'Tuesday'],
  [3, 'Wednesday'],
  [4, 'Thursday'],
  [5, 'Friday'],
  [6, 'Saturday']
]

export const WEEK_DAYS_NAMES_LIST = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
]

export const DEFAULT_SORT = {
  sortedColumn: '',
  sortedColumnOrder: 'descend'
}

export const PER_PAGE_OPTION = {
  pageSizeOptions: ['50', '100', '150', '250'],
  showSizeChanger: true
}

export const DEFAULT_PAGINATION = {
  position: 'both',
  size: 'small',
  total: 0,
  current: 1,
  pageSize: 50,
  defaultCurrent: 1,
  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`
}

export const DEFAULT_PAGINATION_V5 = {
  ...DEFAULT_PAGINATION,
  position: ['topRight', 'bottomRight'],
  showSizeChanger: false
}

export const DEFAULT_PAGINATION_V5_10 = {
  ...DEFAULT_PAGINATION_V5,
  pageSize: 10
}

export const DEFAULT_PAGINATION_V5_15 = {
  ...DEFAULT_PAGINATION_V5,
  pageSize: 15
}

export const DEFAULT_PAGINATION_V5_WITH_PER_PAGE = {
  ...DEFAULT_PAGINATION_V5,
  ...PER_PAGE_OPTION
}

export const DEFAULT_PAGINATION_WITH_PER_PAGE = {
  ...DEFAULT_PAGINATION,
  ...PER_PAGE_OPTION
}

export const PAIN_VALUES = new Map([
  [
    1,
    {
      value: 1,
      title: 'No pain (1)'
    }
  ],
  [
    2,
    {
      value: 2,
      title: 'Minimal (2)'
    }
  ],
  [
    3,
    {
      value: 3,
      title: 'Mild (3)'
    }
  ],
  [
    4,
    {
      value: 4,
      title: 'Moderate (4)'
    }
  ],
  [
    5,
    {
      value: 5,
      title: 'Distracting (5)'
    }
  ],
  [
    6,
    {
      value: 6,
      title: 'Distressing (6)'
    }
  ],
  [
    7,
    {
      value: 7,
      title: 'Intense (7)'
    }
  ],
  [
    8,
    {
      value: 8,
      title: 'Severe (8)'
    }
  ],
  [
    9,
    {
      value: 9,
      title: 'Unable to move (9)'
    }
  ]
])

export const PAIN_VALUES_FOR_DROPDOWN = Array.from(PAIN_VALUES).map(
  ([key, item]) => ({
    key,
    ...item
  })
)

export const MOOD_VALUES = new Map([
  [
    1,
    {
      value: 1,
      title: 'Happines (1)'
    }
  ],
  [
    2,
    {
      value: 2,
      title: 'Joy (2)'
    }
  ],
  [
    3,
    {
      value: 3,
      title: 'Proud (3)'
    }
  ],
  [
    4,
    {
      value: 4,
      title: 'Sadness (4)'
    }
  ],
  [
    5,
    {
      value: 5,
      title: 'Fear (5)'
    }
  ],
  [
    6,
    {
      value: 6,
      title: 'Confused (6)'
    }
  ],
  [
    7,
    {
      value: 7,
      title: 'Worry (7)'
    }
  ],
  [
    8,
    {
      value: 8,
      title: 'Anger (8)'
    }
  ],
  [
    9,
    {
      value: 9,
      title: 'Upset (9)'
    }
  ]
])

export const MOOD_VALUES_FOR_DROPDOWN = Array.from(MOOD_VALUES).map(
  ([key, item]) => ({
    key,
    ...item
  })
)

export const ERRORS_TITLE_LIST = {
  measurements: {
    rawRules: 'Patient Alert Message',
    every: 'Period',
    cmAlertText: 'Care Team Alert Message'
  },
  pathways: {
    noAnswerRuleDto: 'No Answer Rule'
  }
}

// Actions broadcast to the other open tabs (redux-state-sync).
// Only session and UI-state actions belong here. Bootstrap data (profile,
// roles, company data) and websocket-fed counters (alerts, chats, redemption
// badge) must NOT be synced: every tab fetches them itself, and each synced
// action forces a full re-render in every idle tab. The activity timer counter
// (SET_USER_ACTIVITIES_COUNTERS) is the exception: it is only refreshed in the
// tab where the activity is logged, so other tabs need the sync.
export const ACTION_WHITE_LIST = [
  'AUTHENTICATION_STATE_SET',
  'SET_ALERT_PREDEFINED_FILTERS',
  'SET_PATHWAY_PREDEFINED_FILTER',
  'SET_MEDICATION_PREDEFINED_FILTER',
  'SET_MEASUREMENT_PREDEFINED_FILTER',
  'SET_ACTIVITY_LOG_PREDEFINED_FILTER',
  'SET_BILLING_DETAIL_PREDEFINED_FILTER',
  'SET_ENROLLMENT_REPORT_PREDEFINED_FILTER',
  'SET_PREDEFINED_ACTIVITY_DASHBOARD_FILTER',
  'SET_RELOAD_PAGE',
  'SET_IS_URGENT_CARE_USER',
  'SET_RIBBON_TIMESTAMP',
  'SET_USER_ACTIVITIES_COUNTERS',
  'SET_URGENT_CARE_CALL_UUID',
  'SET_ACTIVITY_TIMER_MODAL_INITIAL_VALUES',
  'SET_ACTIVITY_TIMER_MODAL_IS_SUCCESSED',
  'SET_ACTIVITY_TIMER_RECORDING'
]

export const FREQUENCY_TYPE_LIST_NO_PRN = new Map([
  [
    0,
    {
      value: 'recurringDays',
      title: 'Daily',
      fieldTitle: 'day(s)'
    }
  ],
  [
    1,
    {
      value: 'recurringWeeks',
      title: 'Weekly',
      fieldTitle: 'week(s)'
    }
  ],
  [
    2,
    {
      value: 'recurringMonth',
      title: 'Monthly',
      fieldTitle: 'month(s)'
    }
  ],
  [
    3,
    {
      value: 'nonRecurring',
      title: 'Non-Reccurring',
      fieldTitle: ''
    }
  ]
])

export const FREQUENCY_TYPE_LIST = new Map([
  [
    0,
    {
      value: 'recurringDays',
      title: 'Daily',
      fieldTitle: 'day(s)'
    }
  ],
  [
    1,
    {
      value: 'recurringWeeks',
      title: 'Weekly',
      fieldTitle: 'week(s)'
    }
  ],
  [
    2,
    {
      value: 'recurringMonth',
      title: 'Monthly',
      fieldTitle: 'month(s)'
    }
  ],
  [
    3,
    {
      value: 'nonRecurring',
      title: 'Non-Reccurring',
      fieldTitle: ''
    }
  ],
  [
    4,
    {
      value: 'nonRecurringPrn',
      title: 'PRN',
      fieldTitle: ''
    }
  ]
])

export const PROGRAM_PERIOD = [
  { key: 0, value: null, title: 'Custom' },
  { key: 1, value: 30, title: '30 days' },
  { key: 2, value: 60, title: '60 days' },
  { key: 3, value: 90, title: '90 days' }
]

/** Patient Measurements Readings + Graph tabs: 7 / 30 / 90 / Custom (null). */
export const MEASUREMENT_PROGRAM_PERIOD = [
  { key: 0, value: 7, title: '7 days' },
  { key: 1, value: 30, title: '30 days' },
  { key: 2, value: 90, title: '90 days' },
  { key: 3, value: null, title: 'Custom' }
]

export const DISPLAY_PERIOD = [
  { key: 0, value: null, title: 'custom' },
  { key: 1, value: 30, title: '30 days' },
  { key: 2, value: 60, title: '60 days' },
  { key: 3, value: 90, title: '90 days' },
  { key: 4, value: 120, title: '120 days' }
]

export const DEFAULT_RULE = {
  alertPriority: PRIORITY.get(0).value,
  respondTime: 0,
  patientAlertText: null,
  cmAlertText: null
}

export const BILLING_OPTIONS = [
  {
    title: 'All',
    value: null
  },
  {
    title: 'Only Billable (CCM, RPM, RTM, BHI, PIN, CHI, TCM, PCM)',
    value: 'onlyBillable'
  },
  {
    title: 'Only CCM',
    value: 'ccmType'
  },
  {
    title: 'Only RPM',
    value: 'rpmType'
  },
  {
    title: 'Only RTM',
    value: 'rtmType'
  },
  {
    title: 'Only BHI',
    value: 'bhiType'
  }
]

export const PROGRAM_VALUES = [
  {
    title: 'CCM',
    label: 'CCM',
    value: 'ccm'
  },
  {
    title: 'CoCM',
    label: 'CoCM',
    value: 'cocm'
  },
  {
    title: 'RPM',
    label: 'RPM',
    value: 'rpm'
  },
  {
    title: 'RTM',
    label: 'RTM',
    value: 'rtm'
  },
  {
    title: 'BHI',
    label: 'BHI',
    value: 'bhi'
  },
  {
    title: 'APCM',
    label: 'APCM',
    value: 'apcm'
  },
  {
    title: 'PIN',
    label: 'PIN',
    value: 'pin'
  },
  {
    title: 'CHI',
    label: 'CHI',
    value: 'chi'
  },
  {
    title: 'TCM',
    label: 'TCM',
    value: 'tcm'
  },
  {
    title: 'PCM',
    label: 'PCM',
    value: 'pcm'
  }
]

export const PROGRAM_VALUES_WITH_NONE = [
  ...PROGRAM_VALUES,
  {
    title: 'None',
    label: 'None',
    value: 'none'
  }
]

export const PROGRAM_VALUES_WITH_ALL = addAllValue(
  PROGRAM_VALUES_WITH_NONE,
  true,
  'All'
)

export const PROGRAM_VALUES_WITH_ALL_V5 = addAllValueV5({
  list: PROGRAM_VALUES_WITH_NONE
})

export const BILLING_OPTIONS_WITH_NONE = [
  {
    title: 'All',
    value: null
  },
  {
    title: 'Only Billable (CCM, RPM, RTM, BHI, PIN, CHI, TCM, PCM)',
    value: 'onlyBillable'
  },
  {
    title: 'Only CCM',
    value: 'ccmType'
  },
  {
    title: 'Only RPM',
    value: 'rpmType'
  },
  {
    title: 'Only RTM',
    value: 'rtmType'
  },
  {
    title: 'Only BHI',
    value: 'bhiType'
  },
  {
    title: 'None',
    value: 'none'
  }
]

export const AVAILABLE_UPLOAD_FILE_EXTENSIONS =
  '.tiff, .gif, .jpeg, .jpg, .png, .rtf, .ods, .odt, .pdf, .xls, .xlsx, .doc, .docx, .csv, .txt, .dot, .xlt'
export const AVAILABLE_UPLOAD_FILE_EXTENSIONS_LABEL =
  AVAILABLE_UPLOAD_FILE_EXTENSIONS + ' (max size 10MB)'

export const FILE_SIZE_3_MB = 3000000
export const FILE_SIZE_10_MB = 10000000
export const FILE_SIZE_100_MB = 100000000

export const REVERSE_SORTING = ['descend', 'ascend']

export const EXPORT_DELETE_FIELDS = ['page', 'per-page']

export const USER_ADMIN_ROLES = ['Super Admin']

export const PREFERRED_NOTIFICATION_METHOD = [
  {
    key: 0,
    title: 'In-App notification',
    value: 0
  },
  {
    key: 1,
    title: 'Text Messaging',
    value: 1
  },
  {
    key: 2,
    title: 'None',
    value: 2
  },
  {
    key: 3,
    title: 'Email',
    value: 3
  }
]

export const USER_TYPE_ADMIN = 9
export const USER_TYPE_DEFAULT = 1
export const USER_TYPE_PROVIDER_USER = 'provider_user'

export const LANDING_ADRESS = 'https://emmacare.com'
export const GOOGLE_APP_ADRESS = 'http://bit.ly/2STy5nX'
export const APPLE_APP_ADRESS = 'https://apple.co/39ZTeCH'

export const CONFERENCE_URLS = [
  '/actions/telemedicine/video-conference',
  '/actions/urgent-care/video-conference'
]

export const GROUP_BY_FILTER_OPTIONS = [
  {
    title: 'Case manager',
    label: 'Case manager',
    value: 'caseManager',
    key: 'caseManager'
  },
  {
    title: 'Facility',
    label: 'Facility',
    value: 'facility',
    key: 'facility'
  },
  {
    title: 'Provider',
    label: 'Provider',
    value: 'provider',
    key: 'provider'
  },
  {
    title: 'Primary caregiver',
    label: 'Primary caregiver',
    value: 'careGiver',
    key: 'careGiver'
  },
  {
    title: 'Clinician',
    label: 'Clinician',
    value: 'clinician',
    key: 'clinician'
  },
  {
    title: 'Primary insurance',
    label: 'Primary insurance',
    value: 'primaryInsurance',
    key: 'insuranceType'
  },
  {
    title: 'Group',
    label: 'Group',
    value: 'group',
    key: 'group'
  },
  {
    title: 'Referral source',
    label: 'Referral source',
    value: 'referralSource',
    key: 'referralSource'
  }
]

export const DATA_STATES_DROPDOWN = dataStates.map((el) => ({
  ...el,
  key: el.name,
  value: el.abbreviation,
  title: el.name,
  label: el.name
}))

export const ALL_ITEM = {
  key: 'all',
  title: 'All',
  label: 'All',
  value: '',
  children: []
}

export const CUSTOM_FIELDS_TYPES = [
  {
    label: 'String',
    type: 1
  },
  {
    label: 'Checkbox',
    type: 2
  },
  {
    label: 'DateTime',
    type: 3
  },
  {
    label: 'SingleSelect',
    type: 4
  }
]

export const CUSTOM_FIELDS_TREE_DROPDOWN = addAllValueV5({
  convertList: false,
  list: [
    {
      key: '0-0',
      label: 'Yes',
      value: 1
    },
    {
      key: '0-1',
      label: 'No',
      value: 0
    }
  ]
})

export const RPM_BILLABLE_DROPDOWN = [
  {
    label: 'Only RPM Billable',
    title: 'Only RPM Billable',
    value: '1'
  },
  {
    label: 'Not RPM Billable',
    title: 'Not RPM Billable',
    value: '0'
  }
]

export const RPM_BILLABLE_DROPDOWN_WITH_ALL = addAllValue(RPM_BILLABLE_DROPDOWN)

export const RPM_BILLABLE_DROPDOWN_WITH_ALL_V5 = addAllValueV5({
  list: RPM_BILLABLE_DROPDOWN
})

export const VALIDATE_MESSAGES = {
  required: '${label} is required.',
  string: {
    max: 'Text is too long, no more than ${max} symbols are allowed.'
  },
  array: {
    min: 'Please, add at least one intervention.'
  }
}

export const NOTIFICATION_SEARCH_PATIENT_STATUS_BY_ACTIVITY = [
  {
    label: 'All',
    title: 'All',
    value: null
  },
  {
    label: 'Open',
    title: 'Open',
    value: 'open'
  },
  {
    label: 'Partially Completed',
    title: 'Partially Completed',
    value: 'partiallyCompleted'
  },
  {
    label: 'Completed',
    title: 'Completed',
    value: 'completed'
  }
]

// not used since EM-30804, but still requires revisit, keeping
export const NOTIFICATION_SEARCH_FILTER_STATUS_LIST = [
  {
    label: 'All',
    title: 'All',
    value: null
  },
  {
    label: 'Open',
    title: 'Open',
    value: 1
  },
  {
    label: 'Missed & Refused',
    title: 'Missed & Refused',
    value: '3,5'
  },
  {
    label: 'Completed',
    title: 'Completed',
    value: '2,4'
  }
]

export const HTTP_ACCEPTED = 202
export const HTTP_UNPROCESSABLE = 422

export const CLINICIAN_TYPES = [
  {
    key: 1,
    label: 'Community',
    title: 'Community',
    value: 1
  },
  {
    key: 2,
    label: 'ONTH',
    title: 'ONTH',
    value: 2
  }
]

export const CLINICIAN_TYPES_WITH_ALL_V3 = addAllValue(CLINICIAN_TYPES)
export const CLINICIAN_TYPES_WITH_ALL = addAllValueV5({
  list: CLINICIAN_TYPES,
  convertList: false
})

export const AVAILABLE_UPLOAD_FILE_EXTENSIONS_ANTD =
  '.tiff, .gif, .jpeg, .jpg, .png, .rtf, .ods, .odt, .pdf, .xls, .xlsx, .doc, .docx, .csv, .txt, .dot, .xlt'
